export const case_data=[{
    value:'沧州市供水管网水力模型建设项目',
    keyWord:'河北'
},{
    value:'天津市供水管网智能化管理平台',
    keyWord:'天津'
},{
    value:'天津威立雅水力模型项目',
    keyWord:'天津'
},{
    value:'浙江海宁市供水管网智能化管理平台',
    keyWord:'其它'
},{
    value:'山东省济南市城市供水管网优化系统分析',
    keyWord:'山东'
},{
    value:'河北省沧州市供排水集团水力模型及管网区块化项目',
    keyWord:'河北'
},{
    value:'天津市大港油田智慧水务建设项目',
    keyWord:'天津'
},{
    value:'天津市通用水厂优化调度',
    keyWord:'天津'
},{
    value:'辽宁省水利院输水管线工程水锤分析项目',
    keyWord:'辽宁'
},{
    value:'张家口市云州水库供水工程',
    keyWord:'其它'
},{
    value:'南水北调龙口续建配套工程输水管线项目',
    keyWord:'国家'
},{
    value:'抚远输水工程',
    keyWord:'其它'
},{
    value:'天津市DN2200原水管道修复项目',
    keyWord:'天津'
},{
    value:'刚果（金）输水工程水锤分析项目',
    keyWord:'其它'
},{
    value:'沈阳市大伙房水库输水管线水锤分析',
    keyWord:'辽宁'
},{
    value:'丹东应急引水工程',
    keyWord:'其它'
},{
    value:'黑龙江五常市、海林市、龙江县排水雨水防涝综合规划',
    keyWord:'黑龙江'
},{
    value:'配水管网水质安全保障技术  科技部 863计划',
    keyWord:'其它'
},{
    value:'给水管网水质稳定性关键技术研究  国家“十一·五”科技支撑项目',
    keyWord:'国家'
},{
    value:'既有建筑设备改造关键技术研究  国家“十一·五”科技支撑项目',
    keyWord:'国家'
},{
    value:'“城市供水管网智能管理系统关键技术研究与示范” 国家“十二·五”课题',
    keyWord:'国家'
},{
    value:'基于非稳定流寒冷地区输水管道爆裂机理研究黑龙江自然科学基金重点项目',
    keyWord:'黑龙江'
},{
    value:'城市埋地管线和生命线网络系统抗震防灾技术研究  国家科技部',
    keyWord:'国家'
},{
    value:'北方地区安全饮用水保障技术  科技部863计划',
    keyWord:'国家'
},{
    value:'城市给水管网理论与计算方法的研究  国家自然科学基金',
    keyWord:'其它'
},{
    value:'大规模城市给水管网系统优化改造理论与实践  黑龙江自然科学基金重点项目',
    keyWord:'黑龙江'
},{
    value:'老城区老化给水管网科学改造技术与方法研究  黑龙江科技攻关项目',
    keyWord:'黑龙江'
},{
    value:'磨盘山长距离输水管线安全输水建模与水锤事故分析  黑龙江科技攻关项目',
    keyWord:'黑龙江'
},{
    value:'哈尔滨供水管网数字化及优化分析系统  黑龙江科技攻关项目',
    keyWord:'黑龙江'
},{
    value:'中国大型给水系统控制  英国皇家学会基金中英合作项目',
    keyWord:'其它'
}]